import { Routes } from '@angular/router';
import { DrevManquantesComponent } from './drev-manquantes/drev-manquantes.component';

export const DREV_MANQUANTES_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'liste',
        pathMatch: 'full',
        data: {
            role: 'ORGANISME && DECLARATION_MOUVEMENT_LECTURE',
            menu: { icon: '', libelle: 'menu.drev-manquantes', hide: true }
        }
    },
    {
        path: 'liste',
        component: DrevManquantesComponent
    }
];
